var s = Object.defineProperty, i = (t, r, e) => r in t ? s(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e, n = (t, r, e) => (i(t, typeof r != "symbol" ? r + "" : r, e), e);
class c {
  // Track the number of running tasks
  constructor(r) {
    n(this, "concurrency"), n(this, "queue"), n(this, "running"), this.concurrency = r, this.queue = [], this.running = 0;
  }
  // Add a task to the queue and return a Promise that resolves with the task's result (typed as T)
  add(r) {
    return new Promise((e, u) => {
      this.queue.push(() => r().then(e).catch(u)), this.processQueue();
    });
  }
  // Process tasks in the queue
  async processQueue() {
    if (this.running >= this.concurrency || this.queue.length === 0)
      return;
    const r = this.queue.shift();
    if (r) {
      this.running++;
      try {
        await r();
      } catch (e) {
        console.error("Task failed:", e);
      }
      this.running--, this.processQueue();
    }
  }
}
export {
  c as AsyncQueue
};
//# sourceMappingURL=index.es242.js.map
